import { useContext } from 'react';

import { ActionCableProviderContext } from './ActionCableProvider.context';

export const useActionCable = () => useContext(ActionCableProviderContext);
